const cards = [
  {
    title: '本周必看：星际征途引爆科幻热潮',
    desc: '年度最受期待的科幻巨制终于上线，视觉效果突破想象极限，影迷口碑爆棚。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20spacescape%20with%20warm%20golden%20nebula%2C%20cinematic%20composition%2C%20artistic%20abstract%20style%2C%20rich%20amber%20and%20deep%20space%20tones%2C%20dramatic%20lighting&width=720&height=480&seq=cards-01&orientation=landscape',
    tag: '编辑推荐',
    meta: '2026-07-31',
  },
  {
    title: '暑期档追剧指南：这5部剧让你告别剧荒',
    desc: '从古装权谋到现代都市，精心挑选暑期最值得追的剧集清单。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20summer%20evening%20living%20room%20with%20cozy%20ambiance%2C%20soft%20golden%20light%2C%20artistic%20abstract%20composition%2C%20modern%20home%20cinema%20aesthetic%2C%20relaxing%20atmosphere&width=720&height=480&seq=cards-02&orientation=landscape',
    tag: '追剧必备',
    meta: '2026-07-30',
  },
  {
    title: '韩剧迷福利：下半年最值得期待的5部作品',
    desc: '从浪漫爱情到悬疑惊悚，韩国下半年重磅剧集提前盘点。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20aesthetic%20with%20warm%20autumn%20tones%2C%20artistic%20abstract%20floral%20and%20geometric%20shapes%2C%20soft%20golden%20and%20coral%20palette%2C%20cinematic%20romance%20mood&width=720&height=480&seq=cards-03&orientation=landscape',
    tag: '韩剧精选',
    meta: '2026-07-28',
  },
  {
    title: '国产动漫崛起：这些国漫水准不输日漫',
    desc: '画质精良、剧情在线，国产动漫正在迎来属于自己的黄金时代。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20animation%20style%20abstract%20composition%2C%20flowing%20ink%20and%20color%2C%20warm%20golden%20and%20red%20accents%2C%20modern%20illustration%20feel%2C%20dynamic%20and%20elegant&width=720&height=480&seq=cards-04&orientation=landscape',
    tag: '国漫之光',
    meta: '2026-07-26',
  },
  {
    title: '经典重温：豆瓣9分以上必看华语电影',
    desc: '那些年我们错过的华语佳作，每一部都值得反复品味。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20cinema%20aesthetic%20with%20warm%20sepia%20tones%2C%20nostalgic%20film%20texture%2C%20artistic%20abstract%20composition%2C%20golden%20age%20of%20cinema%20mood%2C%20soft%20dramatic%20lighting&width=720&height=480&seq=cards-05&orientation=landscape',
    tag: '经典回顾',
    meta: '2026-07-25',
  },
  {
    title: '恐怖片爱好者必入：下半年恐怖电影前瞻',
    desc: '从心理惊悚到超自然恐怖，下半年最令人期待的恐怖电影汇总。',
    img: 'https://readdy.ai/api/search-image?query=Atmospheric%20dark%20composition%20with%20warm%20amber%20accents%2C%20artistic%20abstract%20shadow%20play%2C%20cinematic%20horror%20aesthetic%2C%20soft%20dramatic%20mood%2C%20elegant%20minimalist%20style&width=720&height=480&seq=cards-06&orientation=landscape',
    tag: '恐怖推荐',
    meta: '2026-07-23',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              编辑团队精心挑选，发现更多值得看的好内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((card, idx) => (
              <a
                key={idx}
                href="#media"
                className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300"
              >
                <div className="relative aspect-[3/2] overflow-hidden">
                  <img
                    src={card.img}
                    alt={card.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full">
                      {card.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-1">{card.meta}</p>
                  <p className="text-xs text-foreground-500 mt-2 leading-relaxed line-clamp-2">{card.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}